<template>
  <div>
    <el-form ref="queryForm2" :model="queryParams2" :inline="true">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams2.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery2(0)"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams2.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery2(0)"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery2(0)">查询</el-button>
        <!--        <el-button v-permisaction="['config:userStatData:export']" icon="el-icon-download" size="mini" @click="handleQuery2(1)">导出</el-button>-->
      </el-form-item>
    </el-form>

    <el-table
      :data="dateArr"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="日期"
        align="center"
        width="120"
      />
      <el-table-column
        v-for="(item, index) in title"
        :key="index"
        :label="item"
        align="center"
      >
        <el-table-column
          prop="count"
          label="触发次数"
          align="center"
        >
          <template v-slot:default="scope">
            {{ tableData[ scope.row.date][index].count }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cRate"
          label="实际占比"
          align="center"
        >
          <template v-slot:default="scope">
            {{ tableData[ scope.row.date][index].cRate }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="vRate"
          label="数值预算"
          align="center"
        >
          <template v-slot:default="scope">
            {{ tableData[ scope.row.date][index].vRate }}%
          </template>
        </el-table-column>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import { exportStatData, getChessBoardRateStat } from '@/api/statistics/user_remain'
import { getLastDates } from '@/utils'

export default {
  name: 'ChessBoardRate',
  data() {
    return {
      dateArr: [],
      title: [],
      tableData: [],
      coinTotal: 0,
      levelData: [],
      queryParams2: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 0
      }
    }
  },
  created() {
    if (!this.queryParams2.startDate) {
      this.queryParams2.startDate = getLastDates(7)
    }

    if (!this.queryParams2.endDate) {
      this.queryParams2.endDate = getLastDates(1)
    }
    this.getTables()
  },
  methods: {
    handleQuery2(isExport = 0) {
      if (this.queryParams2.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams2.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams2.startDate > this.queryParams2.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.getTables(isExport)
    },
    getTables(isExport) {
      this.queryParams2.type = 0
      if (isExport) {
        this.queryParams2.type = 1
      }
      getChessBoardRateStat(this.queryParams2).then(res => {
        if (res.code === 200) {
          if (this.queryParams2.type === 1) {
            window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          }
          const { types, data } = res.data
          this.title = []
          const dateArr = []
          for (const i in types) {
            this.title.push(types[i])
          }
          const tableData = {}
          for (const i in data) {
            const val = data[i]
            if (tableData[val.date] === undefined) {
              tableData[val.date] = []
              dateArr.push({ date: val.date })
            }

            const len = tableData[val.date].length
            tableData[val.date][len] = {
              count: val.count,
              vRate: val.vRate,
              cRate: val.cRate
            }
          }

          this.tableData = tableData
          this.dateArr = dateArr
          // this.tableCoinData = res.data.list.list
          // this.queryParams.startDate = res.data.req.startDate
          // this.queryParams.endDate = res.data.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData(typ) {
      let start = ''
      let end = ''
      this.handleQuery2(false)
      start = this.queryParams2.startDate
      end = this.queryParams2.endDate

      if (start === '' || end === '') {
        return
      }
      exportStatData({ startDate: start, endDate: end, type: typ }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }

  }
}
</script>

<style scoped>

</style>
